import { ReactNode } from "react";

interface ContaierProp {
  children: ReactNode;
}

function Contaier({ children }: ContaierProp) {
  return <div className="container-sm">{children}</div>;
}

export default Contaier;
